import { RUNTIME_ENV_TAGS } from "./constants.js";
import { z } from "zod";
// src/env/schemas.ts
const runtimeEnvTagSchema = z.enum(RUNTIME_ENV_TAGS).default("development");
export { runtimeEnvTagSchema };

//# sourceMappingURL=schemas.js.map